// @flow
import { path } from 'ramda'

import { getTvShowGenres } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_TVSHOW_GENRES = 'tvshows/FETCH_GENRES'

const fetchTVShowGenresAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_TVSHOW_GENRES,
    payload: getTvShowGenres(publicApi, serviceSpec),
    meta: { ttl },
  })
}

// eslint-disable-next-line complexity
export const fetchTVShowGenres = (serviceSpec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchTVShowGenresAction(serviceSpec))

  const state = getState()
  const expires = path(['tvshowGenres', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchTVShowGenresAction(serviceSpec))
}
